export { default as ChildSafetyStandard } from './ChildSafetyStandard';
export { default as CommunityGuidelines } from './CommunityGuidelines';
export { default as PrivacyPolicy } from './PrivacyPolicy';
export { default as StopTheHate } from './StopTheHate';
export { default as TermsAndConditions } from './TermsAndConditions';
